// Only use ISO country codes: https://www.iso.org/iso-3166-country-codes.html
export enum AddressCountry {
    NL = 'NL',
}
